import {SELECT_CHIP} from '../constants/actionTypes';

export function selectChip(chipIndex) {
    return {type: SELECT_CHIP, chipIndex};
}



// WEBPACK FOOTER //
// ./src/actions/raceCardActions.js